import { z } from 'zod';
import { entityIdSchema } from '@kop/contracts';
export const riskResponsiblePersonSchema = z.object({
    identityId: entityIdSchema,
    displayName: z.string().trim().min(1).max(200),
    contractorId: entityIdSchema.nullable(),
}).strict();
export const riskResponsiblePersonPageSchema = z.object({
    items: z.array(riskResponsiblePersonSchema).max(50),
    nextCursor: entityIdSchema.nullable(),
    heldCount: z.number().int().min(0).max(50),
}).strict();
